import React from 'react';

import { SVGComponentProps } from './svg.types';

const ColorToolSVG = ({
  fill = 'currentColor',
  size = '1em',
  ...otherSVGProps
}: SVGComponentProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 12 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherSVGProps}
    >
      <path
        d="M5.99991 0C5.99991 0 0.749893 5.00001 0.749893 8.99999C0.749893 11.7614 3.1004 14 5.99991 14C8.89943 14 11.2499 11.7614 11.2499 8.99999C11.2499 5.00001 5.99991 0 5.99991 0ZM2.49993 9.03037C2.49993 7.16976 4.33368 4.50332 5.99994 2.625V12.25C4.07003 12.25 2.49993 10.8059 2.49993 9.03037Z"
        fill={fill}
      />
    </svg>
  );
};

export default ColorToolSVG;
